// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.styles_pageContainer__Gon6S {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.styles_containerSection__ELL5R {
  width: 25rem;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.styles_title__ZF363 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles_title__ZF363 h2 {
  font-family: "Inter";
  font-size: 16px;
  color: #18316e;
}

.styles_container__buttons__GzNs0 {
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  margin-top: 2rem;
  display: flex;
}

.styles_botao__limpar__T8Acu {
  border: 1px solid #18316e !important;
  color: #18316e !important;
  background-color: transparent !important;
}

.styles_botao__enviar__pVwwA {
  background-color: #18316e !important;
  color: #fff !important;
}

.styles_botao__pesquisar__yvi7X {
  min-width: 40px !important;
  margin-left: 8px !important;
  background-color: #18316e !important; /* Cor igual ao botão "Enviar" */
  color: #fff !important; /* Cor do texto */
  transition: transform 0.3s ease-in-out !important;
}

.styles_botao__limpar__T8Acu,
.styles_botao__enviar__pVwwA {
  width: 10rem !important;
  transition: transform 0.3s ease-in-out !important;
}

.styles_botao__enviar__pVwwA:hover,
.styles_botao__pesquisar__yvi7X:hover {
  background-color: #18316e !important;
  transform: scale(0.95) !important;
}

.styles_botao__limpar__T8Acu:hover {
  transform: scale(0.95) !important;
  background-color: transparent !important;
}

@media (max-width: 425px) {
  .styles_containerSection__ELL5R {
    width: 70vw;
  }

  .styles_container__buttons__GzNs0 {
    justify-content: center;
    gap: 1rem;
  }

  .styles_botao__limpar__T8Acu,
  .styles_botao__enviar__pVwwA {
    width: 100vw !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC,EAAE,gCAAgC;EACtE,sBAAsB,EAAE,iBAAiB;EACzC,iDAAiD;AACnD;;AAEA;;EAEE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.pageContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.containerSection {\n  width: 25rem;\n  gap: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.title h2 {\n  font-family: \"Inter\";\n  font-size: 16px;\n  color: #18316e;\n}\n\n.container__buttons {\n  justify-content: space-between;\n  flex-wrap: wrap-reverse;\n  margin-top: 2rem;\n  display: flex;\n}\n\n.botao__limpar {\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n  background-color: transparent !important;\n}\n\n.botao__enviar {\n  background-color: #18316e !important;\n  color: #fff !important;\n}\n\n.botao__pesquisar {\n  min-width: 40px !important;\n  margin-left: 8px !important;\n  background-color: #18316e !important; /* Cor igual ao botão \"Enviar\" */\n  color: #fff !important; /* Cor do texto */\n  transition: transform 0.3s ease-in-out !important;\n}\n\n.botao__limpar,\n.botao__enviar {\n  width: 10rem !important;\n  transition: transform 0.3s ease-in-out !important;\n}\n\n.botao__enviar:hover,\n.botao__pesquisar:hover {\n  background-color: #18316e !important;\n  transform: scale(0.95) !important;\n}\n\n.botao__limpar:hover {\n  transform: scale(0.95) !important;\n  background-color: transparent !important;\n}\n\n@media (max-width: 425px) {\n  .containerSection {\n    width: 70vw;\n  }\n\n  .container__buttons {\n    justify-content: center;\n    gap: 1rem;\n  }\n\n  .botao__limpar,\n  .botao__enviar {\n    width: 100vw !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `styles_pageContainer__Gon6S`,
	"containerSection": `styles_containerSection__ELL5R`,
	"title": `styles_title__ZF363`,
	"container__buttons": `styles_container__buttons__GzNs0`,
	"botao__limpar": `styles_botao__limpar__T8Acu`,
	"botao__enviar": `styles_botao__enviar__pVwwA`,
	"botao__pesquisar": `styles_botao__pesquisar__yvi7X`
};
export default ___CSS_LOADER_EXPORT___;
